export const getCurrencyValue = (code) => {
  switch (code) {
    case 'ils': return '₪'
    case 'usd': return '$'
    case 'eur': return '€'
    default: return ''
  }
};